<template>
  <header class="fixed w-full z-10 pin-t bg-white" :class="customClass">
    <Popover class="relative max-w-6xl mx-auto px-4 sm:px-6 xs:py-3 mini:py-3">
      <div
        class="
          flex
          justify-between
          items-center
          py-1
          md:justify-start md:space-x-10
        "
      >
        <div class="flex justify-start lg:w-0 lg:flex-1">
          <a href="https://www.vivaaerobus.com/es-mx/">
            <span class="sr-only">VivaAerobus</span>
            <img
              class="h-7"
              src="@/assets/img/viva-logo.svg"
              alt="VivaAerobus"
            />
          </a>
        </div>
        <router-link to="/login" v-if="e == 'test'"> Login</router-link>
        <router-link to="/membresia" v-if="e == 'test'">
          Thank you page</router-link
        >
        <div class="flex items-center justify-end md:flex-1 lg:w-0">
          <button class="hidden md:block mx-2">
            <a href="https://www.vivaaerobus.com/es-mx/"
              ><img
                class="h-14 w-auto"
                src="@/assets/img/logo-viva-fan-v-3.svg"
                alt="VivaAerobus"
            /></a>
          </button>
          <span class="px-2 text-gray-300" v-if="e == 'test'"> | </span>
          <button
            class="
              md:block
              mx-2
              flex
              w-20
              border-b-4
              hover:border-red-200
              border-white
              py-1
            "
            @click.prevent="onCloseModalTranslation()"
          >
            <img
              :src="setupTranslation.languageImage"
              class="w-5 h-5 inline-block mr-2"
            />
            <span class="text-sm"> {{ setupTranslation.currency }} </span>
          </button>
          <a
            href="#"
            @click.prevent="onRedirect()"
            tag="button"
            class="md:block mx-8 font-bold"
            v-if="!isLoggedIn"
          >
            <FontAwesomeIcon :icon="faUser" />
          </a>
          <PopoverGroup
            v-if="account.personalDetails"
            as="nav"
            class="flex space-x-10 mx-5"
          >
            <Popover class="relative" v-slot="{ open }">
              <PopoverButton
                :class="[
                  open ? 'text-gray-900' : 'text-gray-500',
                  'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none',
                ]"
              >
                <FontAwesomeIcon :icon="faUser" />
                <span v-if="account.personalDetails" class="ml-2">
                  {{ account.personalDetails.name.firstName }}
                </span>
                <ChevronDownIcon
                  :class="[
                    open ? 'text-gray-600' : 'text-gray-400',
                    'ml-2 h-5 w-5 group-hover:text-gray-500',
                  ]"
                  aria-hidden="true"
                  v-if="isLoggedIn"
                />
              </PopoverButton>
              <!-- <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1"> -->
              <PopoverPanel
                class="
                  absolute
                  z-10
                  -ml-4
                  mt-3
                  transform
                  px-2
                  max-w-xs
                  w-48
                  sm:px-0
                  lg:ml-0 lg:left-1/2 lg:-translate-x-1/2
                  right-0
                "
              >
                <div
                  class="
                    rounded-lg
                    shadow-lg
                    ring-1 ring-black ring-opacity-5
                    overflow-hidden
                  "
                  v-show="isLoggedIn"
                >
                  <div class="relative grid gap-1 bg-white p-0 sm:gap-1">
                    <a
                      v-for="item in solutions"
                      :key="item.name"
                      @click="goToPath(item)"
                      class="
                        p-3
                        flex
                        items-start
                        rounded-lg
                        hover:bg-gray-50
                        text-center
                        cursor-pointer
                      "
                      v-show="item.show"
                    >
                      <component
                        :is="item.icon"
                        class="flex-shrink-0 h-6 w-6 text-indigo-600"
                        aria-hidden="true"
                      />
                      <div class="ml-4">
                        <p
                          class="
                            text-base
                            font-medium
                            text-gray-900 text-center
                            flex
                          "
                        >
                          {{ item.title }}
                          <LogoutIcon
                            class="w-4 ml-2"
                            v-if="item.name == 'Logout'"
                          />
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </PopoverPanel>
              <!-- </transition> -->
            </Popover>
          </PopoverGroup>
          <!-- <router-link to="/login" class="bg-blue-100 hover:bg-blue-200 px-5 py-1 text-white rounded-lg font-bold mx-2"> Login in-site </router-link> -->
        </div>
      </div>
    </Popover>
    <ModalTranslationCurrency
      :show="showTranslation"
      @close="onCloseModalTranslation"
    />
    <slot></slot>
  </header>
</template>
<script>
import { computed, ref } from "@vue/reactivity";
import { useStore } from "vuex";
import {
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from "@headlessui/vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import { LogoutIcon } from "@heroicons/vue/solid";
import { checkoutTranslate } from "@/translations/Checkout.js";
import ModalTranslationCurrency from "@/components/modals/ModalTranslationCurrency.vue";
import { env } from "../../api/environment";
import { MenuIcon } from "@heroicons/vue/outline";
import { useRouter } from "vue-router";

import imgUS from "@/assets/img/icons/en-us.svg";
import imgMX from "@/assets/img/icons/es-mx.svg";

export default {
  props: ["customClass"],
  components: {
    ModalTranslationCurrency,
    FontAwesomeIcon,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    ChevronDownIcon,
    LogoutIcon,
    MenuIcon,
  },
  setup() {
    const store = useStore();
    const e = env;
    const router = useRouter();
    const account = computed(() => {
      return store.state.Accounts.data ? store.state.Accounts.data : {};
    });
    const isLoggedIn = computed(() => {
      return Object.keys(account.value).length != 0 ? true : false;
    });
    const hasSubscription = computed(() => {
      return store.state.Checkout.data.userSubscription.data ? true : false;
    });

    const showTranslation = ref(false);
    const language = computed(() => {
      return localStorage.getItem("viva-translate")
        ? localStorage.getItem("viva-translate")
        : "es";
    });

    const onRedirect = () => {
      window.location.href = `https://www.vivaaerobus.com/es-mx/?loginType=vivafan&showLogin=true&loginRedirect=true&redirectUrl=${window.location.href.replace(
        /\/$/,
        ""
      )}`;
    };
    const currency = computed(() => {
      return localStorage.getItem("viva-currency")
        ? localStorage.getItem("viva-currency")
        : "MXN";
    });

    const setupTranslation = ref({
      language: language.value,
      currency: currency.value,
      languageImage: language.value == "es" ? imgMX : imgUS,
    });

    const goToPath = async (item) => {
      if (item.name == "Logout") {
        await store.dispatch("onLogout");
        location.href = "/";
      } else {
        router.push({ name: "DashboardSubscription" });
      }
    };

    const onCloseModalTranslation = () => {
      showTranslation.value = !showTranslation.value;
    };
    const onReload = () => {
      const url = window.location.href;
      const slash = url.substr(url.length - 1);
      if (slash === "/") {
        window.location.href = url.slice(0, -1);
      } else {
        window.location.href = url;
      }
    };
    const setTranslate = () => {
      const lang = language.value == "es" ? "eng" : "es";
      localStorage.setItem("viva-translate", lang);
      onReload();
    };
    const setCurrency = (currency) => {
      localStorage.setItem("viva-currency", currency);
      onReload();
    };

    const solutions = computed(() => {
      return [
        {
          name: "Dashboard",
          title: "Dashboard",
          href: "/",
          show: hasSubscription.value,
        },
        {
          name: "Logout",
          title: checkoutTranslate[language.value].user.signoff,
          href: "logout",
          show: isLoggedIn.value,
        },
      ];
    });

    return {
      setupTranslation,
      isLoggedIn,
      faUser,
      account,
      solutions,
      language,
      currency,
      hasSubscription,
      goToPath,
      setTranslate,
      setCurrency,
      onCloseModalTranslation,
      showTranslation,
      imgMX,
      imgUS,
      onRedirect,
      e,
    };
  },
};
</script>
